export default {
  'zh-CN': {
    maximumText: '最大值',
    minimumText: '最小值',
    pleaseEnterLessThan: '请输入小于等于',
    valueOf: '的值',
    withinFiveDigits: '请输入小数点后5位内的数值，超出将清空',
    pleaseEnterMoreThan: '请输入大于等于'
  },
  'en': {
    maximumText: 'Maximum',
    minimumText: 'Minimum',
    pleaseEnterLessThan: 'Please enter less than or equal to',
    valueOf: 'Value',
    withinFiveDigits: 'Please enter the value within 5 decimal places. Any more will be cleared',
    pleaseEnterMoreThan: '请输入大于等于'
  },
  'ja': {
    pleaseEnterLessThan: '以下を入力してください',
    valueOf: 'の値',
    withinFiveDigits: '小数点以下5桁以内の値を入力してください。超過するとクリアされます',
    pleaseEnterMoreThan: '大なり記号を入力してください'
  }
}
